import React, { useEffect, useMemo, useState } from 'react';
import CashSessionGate from './components/CashSessionGate';
import SessionSummary from './components/SessionSummary';
import { getAccounts } from './api/posApi';

const getAccountId = (account) => String(account?._id || account?.id || '');
const getAccountStoreId = (account) => String(account?.linked_store_id || account?.store_id || '');
const getAccountLabel = (account) => account?.name || account?.account_name || `Caisse ${getAccountId(account)}`;

const PosCashSessionsView = () => {
  const defaultStoreId = sessionStorage.getItem('default_store_id') || '';
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [session, setSession] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadAccounts = async () => {
      try {
        const data = await getAccounts({ type: 'cash_register' });
        const list = Array.isArray(data) ? data : data?.response || [];
        if (!mounted) return;
        setAccounts(list);
        const defaultMatch = list.find((account) => getAccountStoreId(account) === defaultStoreId);
        setSelectedAccountId(getAccountId(defaultMatch || list[0] || {}));
      } catch (error) {
        if (!mounted) return;
        setAccounts([]);
      }
    };
    loadAccounts();
    return () => {
      mounted = false;
    };
  }, [defaultStoreId]);

  const selectedAccount = useMemo(
    () => accounts.find((account) => getAccountId(account) === selectedAccountId),
    [accounts, selectedAccountId]
  );

  const storeId = getAccountStoreId(selectedAccount) || defaultStoreId;

  return (
    <div className="container py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <h1 className="h3 fw-bold mb-1">Sessions caisse</h1>
          <p className="text-muted mb-0">Ouverture, suivi et résumé de caisse par compte.</p>
        </div>
        <select
          className="form-select"
          style={{ maxWidth: 360 }}
          value={selectedAccountId}
          onChange={(event) => setSelectedAccountId(event.target.value)}
        >
          {accounts.length === 0 && <option value="">Caisse par défaut</option>}
          {accounts.map((account) => (
            <option key={getAccountId(account)} value={getAccountId(account)}>
              {getAccountLabel(account)}{getAccountStoreId(account) ? ` - ${getAccountStoreId(account)}` : ''}
            </option>
          ))}
        </select>
      </div>
      <CashSessionGate storeId={storeId} onSessionReady={setSession}>
        <SessionSummary sessionId={session?._id} />
      </CashSessionGate>
    </div>
  );
};

export default PosCashSessionsView;
